export enum WebPlanTier {
  Tier1 = 'tier1',
  Tier2 = 'tier2',
  Tier3 = 'tier3',
}

export const WebPlanDetails = {
  tier0: {
    name: 'Basic Plan',
    token: 10,
    creationToken: 5,
    storage: 150,
    unlockOcr: false,
    unlockTokenOffer: false,
    monthlyPrice: null,
    yearlyPrice: null,
  },
  [WebPlanTier.Tier1]: {
    name: 'Silver Plan',
    token: 40,
    creationToken: 20,
    storage: 1000,
    unlockOcr: true,
    unlockTokenOffer: false,
    monthlyPrice: {
      HKD: 2800,
      USD: 399,
      TWD: 12000,
      CNY: 2500,
      // JPY: 60000,
    },
    yearlyPrice: {
      HKD: 26800,
      USD: 3399,
      TWD: 110000,
      CNY: 23800,
      // JPY: 490000,
    },
  },
  [WebPlanTier.Tier2]: {
    name: 'Gold Plan',
    token: 100,
    creationToken: 50,
    storage: 3000,
    unlockOcr: true,
    unlockTokenOffer: true,
    monthlyPrice: {
      HKD: 6800,
      USD: 899,
      TWD: 28000,
      CNY: 6500,
      // JPY: 130000,
    },
    yearlyPrice: {
      HKD: 58800,
      USD: 7599,
      TWD: 240000,
      CNY: 53800,
      // JPY: 1100000,
    },
  },
  [WebPlanTier.Tier3]: {
    name: 'Diamond Plan',
    token: 240,
    creationToken: 120,
    storage: 9000,
    unlockOcr: true,
    unlockTokenOffer: true,
    monthlyPrice: {
      HKD: 13800,
      USD: 1799,
      TWD: 42000,
      CNY: 12800,
      // JPY: 260000,
    },
    yearlyPrice: {
      HKD: 118800,
      USD: 15099,
      TWD: 480000,
      CNY: 106800,
      // JPY: 2180000,
    },
  },
};
